import React from "react";
import { TextField, TextFieldProps } from "formik-mui";
import InputAdornment from "@mui/material/InputAdornment";
import { useField, useFormikContext } from "formik";
import * as yup from "yup";
import CardBrands from "@app.automotus.io/components/icons/CardBrands";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export const CardNumberField = Object.assign(
  ({
    name = "cardNumber",
    id = "card-number",
    label = "Card Number",
    placeholder = "Card Number",
    required = true,
    fullWidth = true,
    ...rest
  }: CardNumberFieldProps) => {
    const form = useFormikContext();
    const [field, meta, { setValue }] = useField(name);

    const handleChange = React.useCallback(
      (event) => {
        const onlyNums = event.target.value.substr(0, 19).replace(/[^0-9]/g, "");
        setValue(onlyNums);
      },
      [setValue],
    );

    return (
      <Box>
        <Typography variant="body3" sx={{ fontWeight: 500 }}>
          {label} *
        </Typography>
        <TextField
          InputLabelProps={{ shrink: false }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <CardBrands />
              </InputAdornment>
            ),
          }}
          helperText={" "}
          {...rest}
          {...{ id, placeholder, required, fullWidth }}
          label=""
          meta={meta}
          form={form}
          field={{
            ...field,
            onChange: handleChange,
          }}
          sx={{ mt: 1 }}
        />
      </Box>
    );
  },
  {
    defaultInitialValue: "",
    validationSchema: yup
      .string()
      .required("Valid card number required.")
      .max(19, "19 numbers maximum.")
      .min(12, "12 numbers minimum."),
  },
);

export interface CardNumberFieldProps extends Omit<TextFieldProps, "meta" | "form" | "field"> {
  name?: string;
}

export default CardNumberField;
